import { render, staticRenderFns } from "./Medidas.vue?vue&type=template&id=4a44a5b1&scoped=true&"
import script from "./Medidas.vue?vue&type=script&lang=js&"
export * from "./Medidas.vue?vue&type=script&lang=js&"
import style0 from "./Medidas.vue?vue&type=style&index=0&id=4a44a5b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a44a5b1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VContainer,VDivider,VFlex,VIcon,VLayout})
